import { DisconnectOutlined } from "@ant-design/icons";
import { App, Spin } from "antd";
import { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { useNetworkStatus } from "../hooks/useNetworkStatus.ts";

export const OfflineBlocker = () => {
  const { isOnline } = useNetworkStatus();
  const { message } = App.useApp();
  const { t } = useTranslation();
  const wasOfflineRef = useRef(false);

  useEffect(() => {
    if (!isOnline) {
      wasOfflineRef.current = true;
    } else if (wasOfflineRef.current) {
      wasOfflineRef.current = false;
      void message.success(t("offline.restored"));
    }
  }, [isOnline, message, t]);

  if (isOnline) {
    return null;
  }

  return <Spin description={t("offline.title")} fullscreen indicator={<DisconnectOutlined />} />;
};
